import { render, staticRenderFns } from "./pt-menu-tree.vue?vue&type=template&id=297caa28&"
import script from "./pt-menu-tree.vue?vue&type=script&lang=js&"
export * from "./pt-menu-tree.vue?vue&type=script&lang=js&"
import style0 from "./pt-menu-tree.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports